export default __webpack_public_path__ + "3339f08fe0e8baf4155da5aa6bad0433.png";